import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('UI Error Boundary caught:', error, errorInfo);
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '24px', maxWidth: '720px', margin: '30px auto', border: '1px solid #fecaca', borderRadius: '12px', background: '#fff1f2' }}>
                    <h2 style={{ marginTop: 0, color: '#991b1b' }}>Something went wrong</h2>
                    <p style={{ color: '#7f1d1d' }}>
                        The page hit an unexpected UI error. You can retry safely without reloading everything.
                    </p>
                    <pre style={{ whiteSpace: 'pre-wrap', color: '#9f1239', fontSize: '12px' }}>
                        {String(this.state.error?.message || 'Unknown UI error')}
                    </pre>
                    <button onClick={this.handleRetry} style={{ border: 0, borderRadius: '8px', padding: '10px 14px', background: '#be123c', color: '#fff', cursor: 'pointer' }}>
                        Retry Render
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
